import { render, staticRenderFns } from "./DeprecatedSelect.vue?vue&type=template&id=46fe35cd"
import script from "./DeprecatedSelect.vue?vue&type=script&lang=js"
export * from "./DeprecatedSelect.vue?vue&type=script&lang=js"
import style0 from "@cognitoforms/styles/app/inputs.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "@cognitoforms/styles/global/_scrollbar.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "./DeprecatedSelect.vue?vue&type=style&index=2&id=46fe35cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.17_css-loader@7.1.2_@rspack+core@1.4.10_@swc+h_d8efeecc32fffa35b7f76004ea8d599d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports